export default "__VITE_ASSET__Dxe9q9_j__"